import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class PlayBlocksListsIcon extends BaseIcon {
    getChildren = () => {
        const color = this.getColor() === 'currentColor' ? '#7985a3' : this.getColor()
        return [
            <g transform="translate(0.75 0.75)">
                <circle cx="0.615" cy="0.615" r="0.615" fill={color} stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                <line x2="11.077" transform="translate(4.923 0.615)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                <circle cx="0.615" cy="0.615" r="0.615" transform="translate(0 5.538)" fill={color} stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                <line x2="11.077" transform="translate(4.923 6.154)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                <circle cx="0.615" cy="0.615" r="0.615" transform="translate(0 11.077)" fill={color} stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                <line x2="11.077" transform="translate(4.923 11.692)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
            </g>
        ]
    }
    getViewBox = () => '0 0 17.5 13.808'
}
